import React, { useState, useEffect } from "react";
import { Tabs,Card, Col,Upload, Row,Button,Form,Select,Modal,Slider,Input,message} from "antd";
import "./Graph.scss";
import {SaveOutlined,DeleteOutlined,InboxOutlined, CloudDownloadOutlined,ConsoleSqlOutlined} from "@ant-design/icons";
import MapPoly from "../../../components/Admin/MapPoly/MapPoly"
import MapAddOrders from "../../../components/Admin/MapAddOrders/MapAddOrders"
import { get} from "../../../api/get";
import {  getAccessTokenApi,getRefreshTokenApi, getPublicIP,getKeyrockTokenApi  } from "../../../api/auth";
import { basePath, apiVersion } from "../../../api/config";
import { deletes } from "../../../api/delete";
import { getExcel } from "../../../api/user";
import TableEditable from "../../../components/table/tableEditable/TableEditable";
import Map_puntos from "../../../components/Admin/Map_puntos";
import DemoPie from "../../../components/Admin/Graphs/Pie/Pie"
import { post } from "../../../api/post";

export default function GraphINPUTS(props) {
  const { Option } = Select;
  const { Dragger } = Upload;
  let search = window.location.search;
  // console.log(search)
  let params = new URLSearchParams(search);
  let code = params.get("id");
  const id_excel = code.replace('.xlsx',''); 
  
  const [data3, setdata3] = useState([]);
  const [puntosHUBS, setpuntosHUBS] = useState([]);
  const [data4, setdata4] = useState([]);
  const [data2, setdata2] = useState([]);
  const [data_IN3_TRANSPTYPES, setdata_IN3_TRANSPTYPES] = useState([]);
  const [puntos, setpuntos] = useState([]);

  const [nombre, setnombre] = useState([]);
  const [isDaily, setisDaily] = useState();
  const [isDailyInit, setisDailyInit] = useState();
  const [nombreInput, setnombreInput] = useState([]);
  const [fecha, setfecha] = useState([]);
  const [cambios, setcambios] = useState(false);
  const [newvehicles, setnewvehicles] = useState([]);
  const [newvehicleshubs, setnewvehicleshubs] = useState([]);
  const [neworders, setneworders] = useState([]);
  const [newhubs, setnewhubs] = useState([]);
  const [cambiosguardados, setcambiosguardados] = useState(false);
  const [viewother, setviewother] = useState(false);
  const [actualizarsimualtionslist, setactualizarsimualtionslist] = useState(false);
  const [selectedSimualtion, setSelectedSimualtion] = useState('');
  const [newName, setnewName] = useState('');
  const [subsimulations, setsubsimulations] = useState([]);
  const [selectactivated1, setselectactivated1] = useState(false);
  const [selectactivated2, setselectactivated2] = useState(false);
  const [selectactivated3, setselectactivated3] = useState(false);
  const [selectactivated4, setselectactivated4] = useState(false);
  
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalVisible2, setIsModalVisible2] = useState(false);
  const [rutarealordersnew, setrutarealordersnew] = useState([]);
  const [rutarealdatanew, setrutarealdatanew] = useState([]);
  const [rutarealorders, setrutarealorders] = useState([]);
  const [rutarealdata, setrutarealdata] = useState([]);
  const [rutarealbool, setrutarealbool] = useState(false);
  const [aux, setAux] = useState(false);
  const [value5, setValue5] = useState([50,50,50,50,50]);
  const [circular, setCircular] = useState(false);

  var data = [
    {
      type: "Distance",
      // type: "Geo-Distribution",
      // type: "Profitability",
      value: Math.round(100*(value5[0])/(value5[0]+value5[1]+value5[2]+value5[3]+value5[4])),
    },
    {
      type: "Time",
      // type: "Systemic Viability",
      // type: "Productivity",
      value: Math.round(100*value5[1]/(value5[0]+value5[1]+value5[2]+value5[3]+value5[4])),
    },
    {
      type: "Emissions",
      // type: "Economic Nature",
      // type: "Systemic Viability",
      value: Math.round(100*value5[2]/(value5[0]+value5[1]+value5[2]+value5[3]+value5[4])),
    },
    {
      type: "% Orders Completed",
      // type: "Channel Capillarity",
      // type: "Safety",
      value: Math.round(100*value5[3]/(value5[0]+value5[1]+value5[2]+value5[3]+value5[4])),
    },
    {
      type: "Price",
      // type: "Operational Compatibility",
      // type: "Working Conditions",
      value: Math.round(100*value5[4]/(value5[0]+value5[1]+value5[2]+value5[3]+value5[4])),
    },
  ];

  const props_ = {
    name: "file",
    multiple: false,
    action: `${basePath}/${apiVersion}/real-routes-database`,
    headers: {
      Authorization: "Bearer " + getAccessTokenApi(),
      refreshToken: "Bearer " + getRefreshTokenApi(),
      functionname:'real-routes-database',
      code:code,
      ippublica:getPublicIP()
    },
    onChange(info) {
      const { status } = info.file;
      console.log('status: ',status)
      console.log('info.file: ',info.file)
      if (status !== "uploading") {
        // setName(JSON.parse(info.file.xhr.response).message);
        // setDisable(false)
      }
      if (status === "done") {
        // setName(JSON.parse(info.file.xhr.response).message);
        // setDisable(false)
        // message.ss(`${info.file.name} file uploaded successfully.`);
        window.location.href = `/admin/graphINPUTS?id=${code}`;
      } else if (status === "error") {
        console.log('info.file.response: ',info.file.response)
        if(info.file.response.error==='ROUTE_1'){
          // notification["error"]({
          //   message: `You must add your own hubs to upload this file.`,
          // });
          message.error(`You must add your own routes in the sheet ROUTE_1`);
        }else if(info.file.response.error==='ROUTE_2'){
          // notification["error"]({
          //   message: `You must add your own vehicles to upload this file.`
          // });
          message.error(`You must add your routes description in the sheet ROUTE_2`);
        }
        // console.log('info')
        // console.log(info)
        // console.log(info.file.response.error)
        // console.log('info')
      }
    },
    onDrop(e) {
    },
    // beforeUpload: (file) => {
    //   return true;
    // },
    beforeUpload: (file) => {
      const fileSize = file.size / 1024 / 1024; // Convert file size to MB
      console.log('tamaño cosas MB: ',fileSize)
      if (fileSize > 10) {
        message.error('File size should be less than 1MB.');
        return false;
      }
      return true;
    }
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleModalOk = () => {
    console.log('ok');
    setIsModalVisible(false);
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
  };

  const handleModalOk2 = () => {
    console.log('ok');
    setIsModalVisible2(false);
  };

  const handleModalCancel2 = () => {
    setIsModalVisible2(false);
  };

  const saveChanges = () => {
    showModal();
  };

  
  const style1 = {
    display: 'flex',
    flexDirection:'column',
    width: 500,
    marginRight:'50px'
  };

  useEffect( () =>  {
    const token = getAccessTokenApi();
    let DATA ;

    var dat={}
    if(viewother){
      dat={is_sub:selectedSimualtion}
    }
    
    (!viewother)
    ?get('getExcelRawInput','getExcelRawInput',`/${id_excel}` ).then((response) => {
    // ?getExcelFromIDInput(token, id_excel).then((response) => {
      DATA = response.DATA;
      console.log('Data: ',response.DATA);
      let subsim=DATA.simulaciones
      var aux=subsim.map(simul => <Option value={simul.nombreInput}>{simul.nombre}</Option>)
      aux.push(<Option value={DATA.nombreInput}>{DATA.nombre}</Option>)
      setsubsimulations(aux)

      let fechas=String(DATA.horaInput).replace('-',' ')
      fechas=fechas.slice(0,-3)
      setfecha(fechas)
      setnombre(DATA.nombre)
      console.log('DATA.simulaciones.Real_Data',DATA.Real_Data)
      console.log('DATA.simulaciones.Real_Data',DATA.Real_Data.routes_data)
      setisDaily(DATA.isDailyOperation||false)
      setisDailyInit(DATA.isDailyOperation||false)
      setrutarealbool(DATA.Real_Data.routes_data.length>0||false)
      if(DATA.Real_Data.routes_data.length>0){
        setrutarealorders(DATA.Real_Data.routes_orders)
        setrutarealdata(DATA.Real_Data.routes_data)
      }
      setnombreInput(DATA.nombreInput)
      if(DATA.pesos.length>0){
        var aux_pesos=[
          parseInt(DATA.pesos[0].distance),
          parseInt(DATA.pesos[0].time),
          parseInt(DATA.pesos[0].emissions),
          parseInt(DATA.pesos[0].ord_complet),
          parseInt(DATA.pesos[0].veh_filling),
        ]
        var maximo = Math.max.apply(null, aux_pesos);
        var minimo = Math.min.apply(null, aux_pesos)-1;
        // console.log(maximo,minimo)
        aux_pesos=[
          parseInt((aux_pesos[0]-minimo)*100/(maximo-minimo)),
          parseInt((aux_pesos[1]-minimo)*100/(maximo-minimo)),
          parseInt((aux_pesos[2]-minimo)*100/(maximo-minimo)),
          parseInt((aux_pesos[3]-minimo)*100/(maximo-minimo)),
          parseInt((aux_pesos[4]-minimo)*100/(maximo-minimo)),
        ]
        setValue5(aux_pesos)
      }

      var col = [];
      Object.keys(DATA.IN3_TranspTypes[0]).map(function (x) {
        col.push({ title: x, dataIndex: x, key: x });
      });
      setdata_IN3_TRANSPTYPES(DATA.IN3_TranspTypes);
      
      col = [];
      Object.keys(DATA.IN2_Hubs[0]).map(function (x) {
        col.push({ title: x, dataIndex: x, key: x });
      });
      setdata3(DATA.IN2_Hubs);
      var puntos_hubs = [];
      DATA.IN2_Hubs.map(function (x) {
        puntos_hubs.push({
          order_id:x.hub_id,
          punto1: [x.hub_lat, x.hub_lon],
          nombre: x.hub_name,
          hub_monthlypayment:x.hub_monthlypayment
        });
      });
      setpuntosHUBS(puntos_hubs);
      
      col = [];
      var vector
      vector=   ['order_id','order_name',	'order_mode',	'order_idhub',	'order_lat1',	'order_lon1',	'order_earlytime1',	'order_latetime1',	'order_servicetime1',	'order_items',	'order_weight',	'order_pc',	'order_lat2',	'order_lon2',	'order_earlytime2',	'order_latetime2',	'order_servicetime2',	'order_bolactivo',	'order_revenue']
      for (let i = 0; i < vector.length; i++) {
        col.push({ title: vector[i], dataIndex: vector[i], key: vector[i] });
      }
      setdata2(DATA.IN1_Orders);

      var puntos2 = [];
      DATA.IN1_Orders.map(function (x) {
        if(x.order_mode==='shipment'){
          puntos2.push({
            order_id:x.order_id+'s',
            punto1: [x.order_lat1, x.order_lon1,''],
            nombre: x.order_id,
            color: "yellow",
            order_mode:x.order_mode,
          });
          puntos2.push({
            order_id:x.order_id+'f',
            punto1: [x.order_lat2, x.order_lon2,''],
            nombre: x.order_id,
            color: "yellow",
            order_mode:x.order_mode,
          });
          
        }else{
          
          puntos2.push({
            order_id:x.order_id,
            punto1: [x.order_lat1, x.order_lon1,''],
            nombre: x.order_id,
            color: "yellow",
            order_mode:x.order_mode,
          });}
        });
      setpuntos(puntos2);
      
      col = [];
      var aux=DATA.IN4_Transp
      Object.keys(DATA.IN4_Transp[0]).map(function (x) {
        col.push({ title: x, dataIndex: x, key: x });
      });
      for (let i = 0; i < aux.length; i++) {
        aux[i]={...aux[i],transp_vehicle_name:DATA.IN3_TranspTypes[aux[i].transp_idtransptype].transptype_name,transp_hub_name:DATA.IN2_Hubs[aux[i].transp_idhub].hub_name}
      }
      setdata4(aux);

      
    })
    // :getSubExcelFromIDInput(token, id_excel,selectedSimualtion).then((response) => {
    :post(dat,'getSubExcelRawInput','getSubExcelRawInput',`/${id_excel}`).then((response) => {
      DATA = response.DATA;
      // console.log('Datas: ',response.DATA);
      var subsim=DATA.simulaciones
      var aux=subsim.map(simul => <Option value={simul.nombreInput}>{simul.name}</Option>)
      aux.push(<Option value={code}>{'Main simulation'}</Option>)
      setsubsimulations(aux)
      
      var fechas=String(DATA.horaInput).replace('-',' ')
      fechas=fechas.slice(0,-3)
      setfecha(fechas)
      setnombre(DATA.nombre)
      setnombreInput(DATA.nombreInput)
      // setcambios(DATA.nombre)
      // if(DATA.pesos.length){
      // // if(DATA.pesos.length>0){
      //   var aux_pesos=[
      //     parseInt(DATA.pesos[0].distance),
      //     parseInt(DATA.pesos[0].time),
      //     parseInt(DATA.pesos[0].emissions),
      //     parseInt(DATA.pesos[0].ord_complet),
      //     parseInt(DATA.pesos[0].veh_filling),
      //   ]
      //   var maximo = Math.max.apply(null, aux_pesos);
      //   var minimo = Math.min.apply(null, aux_pesos)-1;
      //   console.log(maximo,minimo)
      //   aux_pesos=[
      //     parseInt((aux_pesos[0]-minimo)*100/(maximo-minimo)),
      //     parseInt((aux_pesos[1]-minimo)*100/(maximo-minimo)),
      //     parseInt((aux_pesos[2]-minimo)*100/(maximo-minimo)),
      //     parseInt((aux_pesos[3]-minimo)*100/(maximo-minimo)),
      //     parseInt((aux_pesos[4]-minimo)*100/(maximo-minimo)),
      //   ]
      //   setValue5(aux_pesos)
      // }
      
      var col = [];
      Object.keys(DATA.IN3_TranspTypes[0]).map(function (x) {
        col.push({ title: x, dataIndex: x, key: x });
      });
      setdata_IN3_TRANSPTYPES(DATA.IN3_TranspTypes);
      
      col = [];
      Object.keys(DATA.IN2_Hubs[0]).map(function (x) {
        col.push({ title: x, dataIndex: x, key: x });
      });
      setdata3(DATA.IN2_Hubs);
      
      var puntos_hubs = [];
      DATA.IN2_Hubs.map(function (x) {
        puntos_hubs.push({
          order_id:x.hub_id,
          punto1: [x.hub_lat, x.hub_lon],
          nombre: x.hub_name,
          hub_monthlypayment:x.hub_monthlypayment
        });
      });
      setpuntosHUBS(puntos_hubs);
      
      col = [];
      var vector
      vector=   ['order_id','order_name',	'order_mode',	'order_idhub',	'order_lat1',	'order_lon1',	'order_earlytime1',	'order_latetime1',	'order_servicetime1',	'order_items',	'order_weight',	'order_pc',	'order_lat2',	'order_lon2',	'order_earlytime2',	'order_latetime2',	'order_servicetime2',	'order_bolactivo',	'order_revenue']
      for (let i = 0; i < vector.length; i++) {
        col.push({ title: vector[i], dataIndex: vector[i], key: vector[i] });
      }
      setdata2(DATA.IN1_Orders);

      var puntos2 = [];
      DATA.IN1_Orders.map(function (x) {
        if(x.order_mode==='shipment'){
          puntos2.push({
            order_id:x.order_id+'s',
            punto1: [x.order_lat1, x.order_lon1,''],
            nombre: x.order_id,
            color: "yellow",
            order_mode:x.order_mode,
          });
          puntos2.push({
            order_id:x.order_id+'f',
            punto1: [x.order_lat2, x.order_lon2,''],
            nombre: x.order_id,
            color: "yellow",
            order_mode:x.order_mode,
          });
          
        }else{
          
          puntos2.push({
            order_id:x.order_id,
            punto1: [x.order_lat1, x.order_lon1,''],
            nombre: x.order_id,
            color: "yellow",
            order_mode:x.order_mode,
          });}
        });
      setpuntos(puntos2);

      col = [];
      var aux=DATA.IN4_Transp
      Object.keys(DATA.IN4_Transp[0]).map(function (x) {
        col.push({ title: x, dataIndex: x, key: x });
      });
      for (let i = 0; i < aux.length; i++) {
        aux[i]={...aux[i],transp_vehicle_name:DATA.IN3_TranspTypes[aux[i].transp_idtransptype].transptype_name,transp_hub_name:DATA.IN2_Hubs[aux[i].transp_idhub].hub_name}
      }
      setdata4(aux);


    })
    
    setcambios(false)
  }, [actualizarsimualtionslist,setactualizarsimualtionslist]); 

  
  async function deleteSubSim(){
    setIsModalVisible2(true)
  }
  
  async function deleteSubsimulation(){
    try{
      await deletes('user-simulacion-mult/','user-simulacion-mult',id_excel+nombreInput)
      setIsModalVisible2(false)
      message.success(`Subsimulation deleted!`);
      window.location.href = `/admin/graphINPUTS${search}`;
    }catch(e){

    }
  }
  
  const updateName = async (e) => {
    // console.log('estamos:',nombre,nombreInput,newName)
    try{
      const inputs={
        name:newName,
        id_simul_prin:id_excel,
        id_simul_sub:nombreInput,
      }
      await post(inputs,'change-name','change-name','')
      message.success(`Name changed!`);
      window.location.href = `/admin/graphINPUTS${search}`;
    }catch(e){

    }
  }

  const updateOperation = async (e) => {
    // console.log('estamos:',nombre,nombreInput,newName)
    try{
      const inputs={
        isDaily:isDaily,
        id_simul_prin:id_excel,
      }
      await post(inputs,'change-operation','change-operation','')
      setisDailyInit(isDaily)
      message.success(`Changes saved!`);
    }catch(e){

    }
  }
  
  async function updateSimulation(){
    const token = getAccessTokenApi();
    await get('simulateInputDataBBDD','simulateInputDataBBDD',`/${code}` )
    // await simulateInputDataBBDD(token,code,{},true)
    setcambiosguardados(false)
  }

  async function saveChangess(isSaveChanges){
    handleModalOk()
    var data_1 
    if(neworders.length>0){
      data_1 =neworders
      for (let i = 0; i < neworders.length; i++) {
        data_1[i].order_id=parseInt(data_1[i].order_id)
        data_1[i].order_name=String(data_1[i].order_name)
        data_1[i].order_idhub=parseInt(data_1[i].order_idhub)
        data_1[i].order_lat1=parseFloat(data_1[i].order_lat1)
        data_1[i].order_lon1=parseFloat(data_1[i].order_lon1)
        data_1[i].order_lat2=parseFloat(data_1[i].order_lat2)
        data_1[i].order_lon2=parseFloat(data_1[i].order_lon1)
        data_1[i].order_servicetime1=parseInt(data_1[i].order_servicetime1)
        data_1[i].order_servicetime2=parseInt(data_1[i].order_servicetime2)
        data_1[i].order_items=parseInt(data_1[i].order_items)
        data_1[i].order_weight=parseFloat(data_1[i].order_weight)
        data_1[i].order_pc=parseInt(data_1[i].order_pc)
        data_1[i].order_bolactive=parseInt(data_1[i].order_bolactive)
        data_1[i].order_revenue=parseFloat(data_1[i].order_revenue)
      }
    }else{
      data_1 =data2
    }

    var data_2 
    if(newhubs.length>0){
      data_2 =newhubs
      for (let i = 0; i < newhubs.length; i++) {
        data_2[i].hub_id=parseInt(data_2[i].hub_id)
        data_2[i].hub_lat=parseFloat(data_2[i].hub_lat)
        data_2[i].hub_lon=parseFloat(data_2[i].hub_lon)
        data_2[i].hub_monthlypayment=parseFloat(data_2[i].hub_monthlypayment)
      }
    }else{
      data_2 =data3
    }
    
    var data_3 
    if(newvehicles.length>0){
      data_3 =newvehicles
      for (let i = 0; i < newvehicles.length; i++) {
        data_3[i].transptype_id=parseInt(data_3[i].transptype_id)
        data_3[i].transptype_name=String(data_3[i].transptype_name)
        data_3[i].transptype_routing=String(data_3[i].transptype_routing)
        data_3[i].transptype_capacityitems=parseInt(data_3[i].transptype_capacityitems)
        data_3[i].transptype_capacityweight=parseFloat(data_3[i].transptype_capacityweight)
        data_3[i].transptype_speed=parseFloat(data_3[i].transptype_speed)
        data_3[i].transptype_fixcost=parseFloat(data_3[i].transptype_fixcost)
        data_3[i].transptype_kmcost=parseFloat(data_3[i].transptype_kmcost)
        data_3[i].transptype_hourcost=parseFloat(data_3[i].transptype_hourcost)
        data_3[i].transptype_co2emissions=parseFloat(data_3[i].transptype_co2emissions)
      }
    }else{
      data_3 =data_IN3_TRANSPTYPES
    }

    var data_4 
    if(newvehicleshubs.length>0){
      data_4 =newvehicleshubs
      for (let i = 0; i < newvehicleshubs.length; i++) {
        data_4[i].transp_id=parseInt(data_4[i].transp_id)
        data_4[i].transp_idhub=parseInt(data_4[i].transp_idhub)
        data_4[i].transp_num=parseInt(data_4[i].transp_num)
        data_4[i].transp_idtransptype=parseInt(data_4[i].transp_idtransptype)
      }
    }else{
      data_4 =data4
    }
    const data_4_ = data_4.map(({ transp_vehicle_name, transp_hub_name, ...rest }) => rest);

    // const token = getAccessTokenApi();
    const data={
      IN1_Orders:data_1,
      IN2_Hubs: data_2,
      IN3_TranspTypes: data_3,
      IN4_Transp:data_4_
    }
    // console.log(data)
    
    // await updateInputDataBBDD(token,code,data,isSaveChanges)
    if(isSaveChanges){
      await post(data,'updateInputDataBBDD','updateInputDataBBDD',`/${code}`)
    }else{
      await post(data,'updateInputDataBBDDNew','updateInputDataBBDDNew',`/${code}`)
    }
    
    setcambios(false)
    setactualizarsimualtionslist(!actualizarsimualtionslist)
    if(isSaveChanges)setcambiosguardados(true)
  }

  function selectSubsim(value){
    setSelectedSimualtion(value)
    console.log(value)
    if(value===code){
      setviewother(false)
    }else setviewother(true)
    setselectactivated1(true)
    setselectactivated2(true)
    setselectactivated3(true)
    setselectactivated4(true)
    setactualizarsimualtionslist(!actualizarsimualtionslist)
  }

  return (
    <>
      <div>
        <Row justify="space-between" gutter={16}>
          <div style={{display:'flex',flexDirection:'row',height:'30px'}} >
          <Form  onSubmit={updateName}>
          <div style={{display:'flex',flexDirection:'row'}} >
          <Form.Item>
          <Input
              type="name"
              style={{fontFamily: 'report'}}
              name="name"
              // value={nombre}
              placeholder={nombre}
              addonBefore="Simulation"
              addonAfter={fecha}
              onChange={(e) =>
                setnewName(e.target.value)
              }
            />
            </Form.Item>
            <p>&nbsp;&nbsp;</p>
            <Form.Item>
            {(nombreInput!==code)?<Button 
                type="primary" 
                style={{
                  backgroundColor:'white',
                  borderWidth:'2px',
                  borderColor:'rgb(35,148,212)',
                  fontSize:'15px',
                  color:'rgb(35,148,212)',
                  fontFamily:'report-bold',
                }} 
                htmlType="submit"
                onClick={updateName}>
                Update Name
              </Button>
              :<Button className="boton"
                  disabled={true}
                  style={{
                    backgroundColor:'rgb(220,220,220)',
                    borderWidth:'2px',
                    color:'grey',
                    fontFamily:'report',
                    fontSize:'12px',
                    borderColor:'grey',
                  }}>
                Update Name
              </Button>}
              </Form.Item>
              </div>
            </Form>
            <p>&nbsp;&nbsp;</p>
            <div style={{display:'flex',flexDirection:'row',height:'30px'}} >
              
                  <div style={{display:'flex',flexDirection:'row'}} >
                    <p style={{fontFamily:'report-bold',marginTop:'5px'}}>
                      Is daily operation? &nbsp;&nbsp;&nbsp;
                    </p>
                      <Select
                        onChange={value => setisDaily(value)}
                        value={isDaily}
                      >
                        <Option value={true}>Yes</Option>
                        <Option value={false}>No</Option>
                      </Select>
                    <p>&nbsp;&nbsp;</p>
                    {(isDailyInit!==isDaily)
                    ?<Button className="boton"
                      style={{
                        backgroundColor:'white',
                        borderWidth:'2px',
                        borderColor:'rgb(35,148,212)',
                        fontSize:'12px',
                        color:'rgb(35,148,212)',
                        fontFamily:'report-bold',
                      }} 
                      onClick={updateOperation}
                      disabled={false}  >
                        Update Operation
                    </Button>
                    :<Button className="boton"
                    style={{
                      backgroundColor:'rgb(220,220,220)',
                      borderWidth:'2px',
                      color:'grey',
                      fontFamily:'report',
                      fontSize:'12px',
                      borderColor:'grey',
                    }} 
                    disabled={true}  >
                      Update Operation
                  </Button>}
                  </div>
              </div>
              <p>&nbsp;&nbsp;</p>
            {(nombreInput!==code)?<Button 
                type="primary" 
                style={{
                  backgroundColor:'white',
                  borderWidth:'2px',
                  borderColor:'red',
                  fontSize:'15px',
                  color:'red',
                  fontFamily:'report-bold',
                }} 
                onClick={()=>deleteSubSim()}>
                <DeleteOutlined style={{
                    color:'red',
                  }}/>
              </Button>
              :<Button className="boton"
                  disabled={true}
                  style={{
                    backgroundColor:'rgb(220,220,220)',
                    borderWidth:'2px',
                    color:'grey',
                    fontFamily:'report',
                    fontSize:'12px',
                    borderColor:'grey',
                  }}>
                <DeleteOutlined style={{
                    color:'grey',
                  }}/>
              </Button>}
              <Modal
                title="Delete subsimulation"
                visible={isModalVisible2}
                onOk={handleModalOk2}
                onCancel={handleModalCancel2}
                footer={null}
              >
                <h2 style={{fontFamily:'report-bold'}}>Do you want to delete subsimulation: {nombre}?</h2>
                <Row justify="space-around">
                <Button
                    type="primary"
                    style={{
                      backgroundColor: 'white',
                      borderWidth: '2px',
                      fontSize: '15px',
                      borderColor:'rgb(35, 148, 212)',
                      color: 'rgb(35, 148, 212)',
                      fontFamily: 'report-bold',
                    }}
                    onClick={handleModalCancel2}
                  >
                    No
                  </Button>
                  
                  <div  style={{width:'10px',}} ></div>
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: 'white',
                      borderWidth: '2px',
                      fontSize: '15px',
                      borderColor:'red',
                      color: 'red',
                      fontFamily: 'report-bold',
                    }}
                    onClick={()=>deleteSubsimulation()}
                  >
                    Yes
                  </Button>
                </Row>
              </Modal>
            {/* <h1 style={{fontFamily:'report-bold'}} >Simulation: {nombre}&nbsp;&nbsp;&nbsp;{fecha}&nbsp;&nbsp;&nbsp;</h1> */}
          </div> 
          <Row span={6}>
              <Select 
                onChange={value => selectSubsim(value)}
                placeholder="Choose a subsimulation">
                {subsimulations}
              </Select>
              <div  style={{width:'10px',}} ></div>
            {(cambiosguardados && code===nombreInput)?<Button 
              type="primary" 
              style={{
                backgroundColor:'white',
                borderWidth:'2px',
                borderColor:'orange',
                fontSize:'15px',
                color:'orange',
                fontFamily:'report-bold',
              }} 
              onClick={()=>updateSimulation()}>
              Simulate
            </Button>
            :<Button className="boton"
                disabled={true}
                style={{
                  backgroundColor:'rgb(220,220,220)',
                  borderWidth:'2px',
                  color:'grey',
                  fontFamily:'report',
                  fontSize:'15px',
                  borderColor:'grey',
                }}>
              Simulate
            </Button>}
            <div  style={{width:'10px',}} ></div>
            {(cambios===true)?<Button 
              type="primary" 
              style={{
                backgroundColor:'white',
                borderWidth:'2px',
                fontSize:'15px',
                color:'rgb(35,148,212)',
                fontFamily:'report-bold',
              }} 
              onClick={()=>saveChanges()}>
              Save changes
            </Button>
            :<Button className="boton"
                disabled={true}
                style={{
                  backgroundColor:'rgb(220,220,220)',
                  borderWidth:'2px',
                  color:'grey',
                  fontFamily:'report',
                  fontSize:'15px',
                  borderColor:'grey',
                }}>
              Save changes
            </Button>}
            <Modal
              title="Save Changes"
              visible={isModalVisible}
              onOk={handleModalOk}
              onCancel={handleModalCancel}
              footer={null}
            >
              <h2 style={{fontFamily:'report-bold'}}>Choose if you want to save the simulation or make a new subsimulation with the changes added.</h2>
              <Row justify="space-around">
              {(code===nombreInput)?<Button
                  type="primary"
                  style={{
                    backgroundColor: 'white',
                    borderWidth: '2px',
                    fontSize: '15px',
                    color: 'rgb(35, 148, 212)',
                    fontFamily: 'report-bold',
                  }}
                  onClick={()=>saveChangess(true)}
                >
                  Save changes
                </Button>
                :<Button
                type="primary"
                disabled={true}
                style={{
                  backgroundColor: 'white',
                  borderWidth: '2px',
                  fontSize: '15px',
                  color: 'grey',
                  fontFamily: 'report-bold',
                }}
              >
                Save changes
              </Button>}
                <div  style={{width:'10px',}} ></div>
                <Button
                  type="primary"
                  style={{
                    backgroundColor: 'white',
                    borderWidth: '2px',
                    fontSize: '15px',
                    color: 'rgb(35, 148, 212)',
                    fontFamily: 'report-bold',
                  }}
                  onClick={()=>saveChangess(false)}
                >
                  Create subsimulation
                </Button>
              </Row>
            </Modal>
          </Row> 
        </Row>
      </div>  
      
      <div className="site-card-wrapper">
        <Tabs defaultActiveKey="1" onChange={() => {}} style={{fontFamily:'report'}}>
          <Tabs.TabPane tab="Vehicles" key="Vehicles" >
            <Row justify="center" gutter={16}>
              <Col span={24}>
                <h1 style={{fontFamily:'report-bold'}} className="titulos">INPUT DATA OF THE VEHICLES</h1>
                {
                  (data_IN3_TRANSPTYPES.length>0)
                    ?<TableEditable
                      cambios={cambios}
                      setcambios={setcambios}
                      newdata={newvehicles}
                      setnewdata={setnewvehicles}
                      selectactivated={selectactivated1}
                      setselectactivated={setselectactivated1}
                      datos={data_IN3_TRANSPTYPES}
                      tipo={'vehicle'}
                      />  
                    :<h2 style={{fontFamily:'report-bold'}}>This simulation has errors, check if you have completed the vehicles info to solve them.</h2>
                }
              </Col>
            </Row>
            <p></p>
            <Row justify="center" gutter={16}>
            <Col span={24}>
                <h1 style={{fontFamily:'report-bold'}}className="titulos">HUBS VEHICLES DISTRIBUTION</h1>
                {
                (data4.length>0)
                  ?<TableEditable
                    cambios={cambios}
                    setcambios={setcambios}
                    newdata={newvehicleshubs}
                    setnewdata={setnewvehicleshubs}
                    selectactivated={selectactivated2}
                    setselectactivated={setselectactivated2}
                    datos={data4}
                    tipo={'match'}
                    />  
                  :<h2 style={{fontFamily:'report-bold'}}>This simulation has errors, check if you have matched the vehicles with your hubs to solve them.</h2>
              }
              </Col>
            </Row>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Orders" key="Orders" >
            <Col span={24}>
              <h1 style={{fontFamily:'report-bold'}}className="titulos">ORDERS INPUT DATA</h1>
              {
                (data2.length>0)
                  ?<TableEditable
                    cambios={cambios}
                    setcambios={setcambios}
                    newdata={neworders}
                    setnewdata={setneworders}
                    selectactivated={selectactivated3}
                    setselectactivated={setselectactivated3}
                    datos={data2}
                    tipo={'orders'}
                    />  
                  :<h2 style={{fontFamily:'report-bold'}}>This simulation has errors, check if you have completed your orders to solve them.</h2>
              }
            </Col>
            <p></p>
            <Row>
              <Col span={24}>
                <h1 style={{fontFamily:'report-bold'}}className="titulos">ORDERS LOCATION - DRAW</h1>
               { (puntos.length>0)
                  ?<MapPoly nombre={nombreInput} isInput={true}></MapPoly>
                  // ?<Map_puntos coordenadas={puntos} />
                  :<h2 style={{fontFamily:'report-bold'}}>This simulation has errors, check the inputs or contact with Capillar IT to solve them.</h2>}
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <h1 style={{fontFamily:'report-bold'}}className="titulos">GET LONGITUDE AND LATITUDE</h1>
               { (puntos.length>0)
                  ?<MapAddOrders nombre={nombreInput} isInput={false}></MapAddOrders>
                  :<h2 style={{fontFamily:'report-bold'}}>This simulation has errors, check the inputs or contact with Capillar IT to solve them.</h2>}
              </Col>
            </Row>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Hubs" key="Hubs" >
            <Row justify="center" gutter={16}>
              <Col span={24}>
                <h1 style={{fontFamily:'report-bold'}}className="titulos">HUBS INPUT DATA</h1>
                {
                (data3.length>0)
                  ?<TableEditable
                    cambios={cambios}
                    setcambios={setcambios}
                    newdata={newhubs}
                    setnewdata={setnewhubs}
                    selectactivated={selectactivated4}
                    setselectactivated={setselectactivated4}
                    datos={data3}
                    tipo={'hubs'}
                    />  
                  :<h2 style={{fontFamily:'report-bold'}}>This simulation has errors, check if you have completed your hubs info to solve them.</h2>
              }
              </Col>
            </Row>
            <p></p>
            <Row justify="center" gutter={16}>
              <Col span={24}>
                <h1 className="titulos">HUBS LOCATION</h1>
                <Card title="Hubs locations: " bordered={false}>
                {
                (puntosHUBS.length>0)
                  ? <Map_puntos coordenadas={puntosHUBS} />
                  :<h2 style={{fontFamily:'report-bold'}}>This simulation has errors, check the inputs or contact with Capillar IT to solve them.</h2>}
                </Card>
              </Col>
            </Row>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Weights" key="Weights" >
            <p></p>
              <div className="weightsRow" >
                <div>
                  <h1 style={{
                    fontFamily:'report',
                    fontSize:'18px',}}>Axe: Distance</h1>
                    {/* fontSize:'18px',}}>Axe: Geo-Distribution</h1> */}
                    {/* fontSize:'18px',}}>Axe: Profitability</h1> */}
                  <div style={style1}>
                    <Slider 
                    tooltip={(value) => `${value}%`}
                    step={1}
                    min={0}
                    max={100}
                    onChange={(newValue) => {
                      var auxiliar=value5
                      auxiliar[0]=newValue
                      setAux(!aux)
                      setValue5(auxiliar);
                    }}
                    value={value5[0]}
                    />
                  </div>
                  <p>&nbsp;</p>
                  <h1 style={{
                    fontFamily:'report',
                    fontSize:'18px',}}>Axe: Time</h1>
                    {/* fontSize:'18px',}}>Axe: Systemic Viability</h1> */}
                    {/* fontSize:'18px',}}>Axe: Productivity</h1> */}
                  <div style={style1}>
                    <Slider 
                    tooltip={(value) => `${value}%`}
                    step={1}
                    min={0}
                    max={100}
                    onChange={(newValue) => {
                      var auxiliar=value5
                      auxiliar[1]=newValue
                      setAux(!aux)
                      setValue5(auxiliar);
                    }}
                    value={value5[1]}
                    />
                  </div>
                  <p>&nbsp;</p>
                  <h1 style={{
                    fontFamily:'report',
                    fontSize:'18px',}}>Axe: Emissions</h1>
                    {/* fontSize:'18px',}}>Axe: Economic Nature</h1> */}
                    {/* fontSize:'18px',}}>Axe: Systemic Viability</h1> */}
                  <div style={style1}>
                    <Slider 
                    tooltip={(value) => `${value}%`}
                    step={1}
                    min={0}
                    max={100}
                    onChange={(newValue) => {
                      var auxiliar=value5
                      auxiliar[2]=newValue
                      setAux(!aux)
                      setValue5(auxiliar);
                    }}
                    value={value5[2]}
                    />
                  </div>
                  <p>&nbsp;</p>
                  <h1 style={{
                    fontFamily:'report',
                    fontSize:'18px',}}>Axe: % Orders Completed</h1>
                    {/* fontSize:'18px',}}>Axe: Channel Capillarity</h1> */}
                    {/* fontSize:'18px',}}>Axe: Safety</h1> */}
                  <div style={style1}>
                    <Slider 
                    tooltip={(value) => `${value}%`}
                    step={1}
                    min={0}
                    max={100}
                    onChange={(newValue) => {
                      var auxiliar=value5
                      auxiliar[3]=newValue
                      setAux(!aux)
                      setValue5(auxiliar);
                    }}
                    value={value5[3]}
                    />
                  </div>
                  <p>&nbsp;</p>
                  <h1 style={{
                    fontFamily:'report',
                    fontSize:'18px',}}>Axe: Price</h1>
                    {/* fontSize:'18px',}}>Axe: Operational Compatibility</h1> */}
                    {/* fontSize:'18px',}}>Axe: Working Conditions </h1> */}
                  <div style={style1}>
                    <Slider 
                    tooltip={(value) => `${value}%`}
                    step={1}
                    min={0}
                    max={100}
                    onChange={(newValue) => {
                      var auxiliar=value5
                      auxiliar[4]=newValue
                      setAux(!aux)
                      setValue5(auxiliar);
                    }}
                    value={value5[4]}
                    />
                  </div>
                </div>
                <div style={{width:'580px',height:'300px'}}>
                  <DemoPie data={data}>
                  </DemoPie>
                </div>
              </div>
              <div className="divClassss">
                <Button className="boton"
                style={{borderColor: "rgb(35,148,212)", 
                borderWidth:'2px',
                fontFamily:'report',
                fontSize:'18px',
                color:'rgb(0,104,178)',
                backgroundColor: "white" }}
                  type="primary"
                  onClick={async () => {
                    const datos = {    
                      name:nombreInput,  
                      distance: Math.round(100*(value5[0])/(value5[0]+value5[1]+value5[2]+value5[3]+value5[4])),
                      time: Math.round(100*value5[1]/(value5[0]+value5[1]+value5[2]+value5[3]+value5[4])),
                      emissions: Math.round(100*value5[2]/(value5[0]+value5[1]+value5[2]+value5[3]+value5[4])),
                      ord_complet: Math.round(100*value5[3]/(value5[0]+value5[1]+value5[2]+value5[3]+value5[4])),
                      veh_filling: Math.round(100*value5[4]/(value5[0]+value5[1]+value5[2]+value5[3]+value5[4])),
                    }
                    setCircular(true)
                    await post(datos,'add-weights','add-weights','')
                    setCircular(false)
                  }}>
                  Save Weights
                  <SaveOutlined />
                </Button>
              </div>
                {
                  (circular)
                    ?<div style={{display:'flex',justifyContent:'center'}}>
                      <div></div>
                      <div className="cargandos"></div>
                      <div></div>
                    </div>
                    :<div className="vacio"></div>
                }
              
          </Tabs.TabPane>
          <Tabs.TabPane tab="Real Routes" key="real_routes" >
            {(!rutarealbool)
            ?<div>
              <Dragger {...props_}>
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <Row justify='center'>
                <Col>
                  <p style={{
                    fontFamily:'report',
                    fontSize:'18px',}} className="ant-upload-text">
                    Click or drag file to this area to upload the data &nbsp;
                  </p>
                </Col>
                <Col>
                  <p style={{
                    fontFamily:'report-bold',
                    fontSize:'17px',}} className="ant-upload-text">
                    WITH YOUR REAL ROUTES
                  </p>
                </Col>
              </Row>
              <p style={{
                fontFamily:'report',
                fontSize:'18px',}} className="ant-upload-text">
                then click NEXT
              </p>
              <p style={{
                fontFamily:'report',
                fontSize:'18px',}} className="ant-upload-hint">
                Support for a single or bulk upload. Strictly prohibit from uploading
                company data or other band files
              </p>
            </Dragger>
            <div className="RowMiddle">
              <Button className="boton"
                disabled={/* disable */false}
                style={{borderColor: "rgb(35,148,212)", 
                borderWidth:'2px',
                fontFamily:'report',
                fontSize:'18px',
                marginTop:'20px',
                color:'rgb(0,104,178)',
                marginRight:'50px',
                backgroundColor: "white" }}
                type="primary"
                onClick={ () => {
                  getExcel(true,true,true,false)
                  }}>
                Download an example "Real Routes" excel
                <CloudDownloadOutlined />
              </Button>
              <Button className="boton"
                style={{borderColor: "rgb(35,148,212)", 
                  borderWidth:'2px',
                  fontFamily:'report',
                  fontSize:'18px',
                  color:'rgb(0,104,178)',
                  marginTop:'20px',
                  backgroundColor: "white" }}
                disabled={/* disable */false}
                
                type="primary"
                onClick={ () => {
                  getExcel(false,true,true,true)
                  }}>
                Download base excel
                <CloudDownloadOutlined />
              </Button>
            </div>
          </div>
          :<div>
            <Row justify="center" gutter={16}>
              <Col span={10}>
                <h1 style={{fontFamily:'report-bold'}} className="titulos">REAL ROUTES ORDER</h1>
                <TableEditable
                      cambios={cambios}
                      setcambios={setcambios}
                      newdata={rutarealordersnew}
                      setnewdata={setrutarealordersnew}
                      selectactivated={selectactivated1}
                      setselectactivated={setselectactivated1}
                      datos={rutarealorders}
                      tipo={'route'}
                      />  
              </Col>
              <Col span={14}>
                <h1 style={{fontFamily:'report-bold'}} className="titulos">REAL ROUTES DATA</h1>
                <TableEditable
                      cambios={cambios}
                      setcambios={setcambios}
                      newdata={rutarealdatanew}
                      setnewdata={setrutarealdatanew}
                      selectactivated={selectactivated1}
                      setselectactivated={setselectactivated1}
                      datos={rutarealdata}
                      tipo={'route_data'}
                      />  
                <div className="divClassss">
                  <Button 
                    className="boton"
                    disabled={!cambios}
                    style={{borderColor: "rgb(35,148,212)", 
                    borderWidth:'2px',
                    fontFamily:'report',
                    fontSize:'18px',
                    color:'rgb(0,104,178)',
                    backgroundColor: "white" }}
                    type="primary"
                    onClick={async () => {
                      console.log('cucu',rutarealordersnew,rutarealdatanew)
                      setCircular(true)
                      var datos0=[]
                      var datos1=[]

                      if(rutarealordersnew.length>0){
                        for(var i=0;i<rutarealordersnew.length;i++){
                          datos0.push({
                            order_id:parseInt(rutarealordersnew[i].order_id),
                            order_position:parseInt(rutarealordersnew[i].order_position),
                            order_idtour:parseInt(rutarealordersnew[i].order_idtour)
                          })
                        }
                      }else datos0=rutarealorders
                      
                      if(rutarealdatanew.length>0){
                        for(var i=0;i<rutarealdatanew.length;i++){
                          datos1.push({
                            id_tour:parseInt(rutarealdatanew[i].id_tour),
                            veh_id:parseInt(rutarealdatanew[i].veh_id),
                            hora_init:rutarealdatanew[i].hora_init,
                            duration_time:parseInt(rutarealdatanew[i].duration_time)
                          })
                        }
                      }else datos1=rutarealdata

                      const datos = {    
                        routes_orders:datos0,
                        routes_data:datos1,
                        code:code
                      }
                      // setCircular(true)
                      await post(datos,'real-routes-database-save','real-routes-database-save','')
                      setCircular(false)
                      message.success('Changes saved!')
                    }}>
                    Save real routes
                    <SaveOutlined />
                  </Button>
                </div>
              </Col>
            </Row>
              {
                (circular)
                  ?<div style={{display:'flex',justifyContent:'center'}}>
                    <div></div>
                    <div className="cargandos"></div>
                    <div></div>
                  </div>
                  :<div className="vacio"></div>
              }
              </div>
            }
          </Tabs.TabPane>
        </Tabs>
      </div>
    </>
  );
}
